<template>
  <v-container fluid>
    <v-row v-if="esAdmin" class="mb-3">
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="empresaid"
          :items="empresas"
          label="Empresa Proveedora"
          item-text="text"
          item-value="value"
          dense
          outlined
          clearable
          @change="cambiarEmpresa"
        />
      </v-col>
    </v-row>

    <!-- ICONOS SUPERIORES -->
    <!-- <v-row justify="end" class="mb-2">
      <v-icon class="mx-2 grey--text text--darken-1">mdi-bell-outline</v-icon>
      <v-icon class="mx-2 grey--text text--darken-1">mdi-email-outline</v-icon>
      <v-icon class="mx-2 grey--text text--darken-1">mdi-cog-outline</v-icon>
      <v-icon class="mx-2 grey--text text--darken-1">mdi-chevron-down</v-icon>
    </v-row> -->

    <!-- FILA SUPERIOR -->
    <v-row dense>
      <v-col cols="12" md="3" v-for="(card, i) in topCards" :key="i">
        <v-sheet
          :color="card.color"
          class="summary-card summary-vertical"
          elevation="0"
        >
          <v-icon size="64" color="#E6E6E6" class="mb-2">
            {{ card.icon }}
          </v-icon>

          <div class="summary-row">
            <span class="summary-number">{{ card.count }}</span>
            <span class="summary-text">{{ card.text }}</span>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- FILA INFERIOR -->
    <v-row dense class="mt-2">
      <v-col cols="12" md="6" v-for="(card, i) in bottomCards" :key="i">
        <v-sheet
          :color="card.color"
          class="summary-card summary-horizontal"
          elevation="0"
        >
          <v-icon size="48" color="#E6E6E6" class="mr-3">
            {{ card.icon }}
          </v-icon>

          <span class="summary-text font-weight-medium">
            {{ card.text }}
          </span>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- LISTA -->
    <v-list dense class="pa-2">
      <v-card
        v-for="(p, i) in postulacionesRecientes"
        :key="p.idpostulacion || i"
        class="mb-3 postulacion-card"
        outlined
      >
        <v-list-item>
          <v-list-item-content>
            <v-row align="center" no-gutters>
              <!-- IZQUIERDA -->
              <v-col cols="5">
                <div class="rq-row">
                  <strong>{{ p.denominacion ? p.denominacion.slice(0, 3) : '' }}</strong>
                  <span > – {{ p.empresa_contacto }}</span>
                </div>

                <v-chip x-small class="mt-1">
                  {{ p.nombre_categoria }}
                </v-chip>
              </v-col>

              <!-- CENTRO -->
              <v-col
                cols="3"
                class="text-center grey--text text-caption"
              >
                {{ formatearFecha(p.fecha) }}
              </v-col>

              <!-- DERECHA -->
              <v-col cols="4" class="text-right">
                <v-chip
                  small
                  dark
                  :color="colorEstado(p.estado)"
                >
                  {{ p.estado ? p.estado.replace(/_/g, ' ') : '' }}
                </v-chip>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-list>

    <v-divider inset />

  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      nuevasOportunidades: 0,
      postulaciones: [],
      requerimientos: [],
      empresas: [],

      empresaid: null,
      idusuario: null,
      rol: null,
      esAdmin: false,
    }
  },

  created () {
    this.idusuario = localStorage.getItem('idusuario')
    // this.empresaid = Number(localStorage.getItem('empresa'))
    this.rol = localStorage.getItem('rol')
    this.esAdmin = this.rol === 'ADMINISTRADOR'
    if(this.esAdmin){

      this.selectEmpresas()

    }else{

      // El proveedor usa su propia empresa
      const empresa = localStorage.getItem('empresa')
      this.empresaid = empresa ? Number(empresa) : null

      if (this.empresaid) {
        this.cargarDashboard()
      } else {
        console.error('El usuario proveedor no tiene empresa asociada')
      }

    }
    // this.listarPostulaciones()
    // this.listarRequerimientos()
  },

  // mounted(){
  //   this.contarNuevasOportunidades()
  // },

  computed: {
    topCards () {
      return [
        {
          // count: this.contarNuevasOportunidades(),
          count: this.nuevasOportunidades,
          text: 'Nuevas Oportunidades',
          icon: 'mdi-magnify',
          color: '#FF6600'
        },
        {
          count: this.contarPorEstado('REGISTRADO'),
          text: 'Postulados',
          icon: 'mdi-check-circle-outline',
          color: '#BABB13'
        },
        {
          count: this.contarPorEstado('EN_EVALUACIÓN'),
          text: 'En Evaluación',
          icon: 'mdi-clipboard-text-outline',
          color: '#0095A9'
        },
        {
          count: this.contarPorEstado('OBSERVADO'),
          text: 'Observados',
          icon: 'mdi-alert-circle-outline',
          color: '#FDB714'
        }
      ]
    },

    bottomCards () {
      return [
        {
          text: `Adjudicados (${this.contarPorEstado('ADJUDICADO')})`,
          icon: 'mdi-trophy-outline',
          color: '#BABB13'
        },
        {
          text: `No Adjudicados (${this.contarPorEstado('NO_ADJUDICADO')})`,
          icon: 'mdi-close-thick',
          color: '#C05026'
        }
      ]
    },

    postulacionesRecientes () {
      return this.postulaciones
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        .slice(0, 5)
    }
  },

  methods: {
    selectEmpresas(){

      this.empresas=[]

      return axios
        .get("api/Empresas/SelectEmpresas")
        .then(res=>{

          this.empresas = res.data.map(x=>({
            text:x.razonsocial,
            value:x.idempresa
          }))
          if(this.empresas.length){
            this.empresaid = this.empresas[0].value
            this.cargarDashboard()
          }
        })
        .catch(err => {
          console.error('Error cargando empresas:', err)
        })

    },
    async cambiarEmpresa(){

      if(!this.empresaid) {
        this.postulaciones = []
        this.nuevasOportunidades = 0
        return
      }

      await this.cargarDashboard()

    },
    async cargarDashboard(){
      if (!this.empresaid) {
        this.postulaciones = []
        this.nuevasOportunidades = 0
        return
      }

      await Promise.all([

        this.listarPostulaciones(),

        this.listarRequerimientos(),

        this.contarNuevasOportunidades()

      ])

    },
    listarRequerimientos () {
      return axios.get('api/Requerimientos/Listar')
        .then(res => {
          this.requerimientos = res.data
        })
        .catch(err => {
          console.error('Error listando requerimientos:', err)
        })
    },

    listarPostulaciones () {
      if (!this.empresaid) {
        this.postulaciones = []
        return Promise.resolve()
      }
      return axios
        .get(`api/PostulacionEmpresas/ListarPorEmpresaPanel/${this.empresaid}`)
        .then(res => {
          this.postulaciones = res.data
        })
        .catch(err => {
          console.error('Error listando postulaciones:', err)
          this.postulaciones = []
        })
    },

    contarNuevasOportunidades () {
      if (!this.empresaid) {
        this.nuevasOportunidades = 0
        return Promise.resolve()
      }
      return axios
        .get('/api/Requerimientos/ContarNoPostuladosPanel', {
          params: { idempresa_envio: this.empresaid }
        })
        .then(res => {
          console.log(res.data)
          this.nuevasOportunidades = res.data
        })
        .catch(err => {
          console.error('Error contando oportunidades:', err)
          this.nuevasOportunidades = 0
        })
    },

    contarPorEstado (estado) {
      if (estado === 'EN_EVALUACIÓN') {
        return this.postulaciones.filter(p =>
          p.estado === 'EN_EVALUACIÓN' ||
          p.estado === 'EN_EVALUACION'
        ).length
      }
      return this.postulaciones.filter(p => p.estado === estado).length
    },

    colorEstado (estado) {
      switch (estado) {
        case 'REGISTRADO': return '#BABB13'
        case 'EN_EVALUACION':
        case 'EN_EVALUACIÓN': return '#0095A9'
        case 'ADJUDICADO': return '#BABB13'
        case 'OBSERVADO': return '#FDB714'
        case 'NO_ADJUDICADO':
        case 'RECHAZADO': return '#C05026'
        default: return '#9E9E9E'
      }
    },
    formatearFecha (fecha) {
      if (!fecha) return '-'

      return fecha
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/')
    },
  }
}
</script>

<style scoped>
.summary-card {
  height: 140px;
  color: #E6E6E6;
  border-radius: 8px;
}

/* ARRIBA */
.summary-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* NUMERO + TEXTO */
.summary-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-number {
  font-size: 34px;
  font-weight: 700;
}

.summary-text {
  font-size: 20px;
  line-height: 1.2;
}

/* ABAJO */
.summary-horizontal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.rq-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rq-code {
  font-size: 16px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.rq-desc {
  font-size: 14px;
  font-weight: 600;
  color: #555;
}
.postulacion-card {
  border-radius: 12px;
  background-color: #ffffff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.postulacion-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

</style>
